import React from "react";
import { JAM_KEYS } from "../../lib/numberSenseData";
import { Icon, Keys } from "../numberSenseUi";

/* ============================================================
   Number Sense — targeted drills (the practice room). Two ways to
   grind: pick a key and drill its scale + diatonic chords cold, or
   run "weak spots" — a session weighted to the chords you miss most.
   Both run through the normal lesson runtime (hearts + XP + mastery)
   but mark no curriculum node.

   Props:
     gameData : { pairs, ... }   to gate weak-spots
     onDrillKey : (key) => void
     onReview   : () => void
     onBack     : () => void
   ============================================================ */
const DrillScreen = ({ gameData, onDrillKey, onReview, onBack }) => {
  const canReview = gameData.pairs.length >= 3;
  return (
    <div className="ns-root">
      <div className="ns-app">
        <div className="subbar">
          <button className="iconbtn" onClick={onBack} aria-label="back">
            <Icon name="back" />
          </button>
          <div className="subbar-title">targeted drills</div>
        </div>
        <div className="scroll">
          <p className="games-intro">
            Pick a key to grind it cold — its scale first, then the chords built
            from that scale, worked from every angle. Or drill the spots you keep
            missing.
          </p>

          <div className="jam-section">drill a key</div>
          <div className="jam-pills">
            {JAM_KEYS.map((k) => (
              <button
                key={k}
                className="jam-pill mono"
                onClick={() => onDrillKey(k)}
              >
                {k}
              </button>
            ))}
          </div>

          <div className="jam-section">review</div>
          {canReview ? (
            <button className="games-entry" onClick={onReview}>
              <div className="ic">
                <Icon name="swap" />
              </div>
              <div className="txt">
                <div className="ttl">weak spots</div>
                <div className="sub">
                  a quick session weighted to the chords you miss most
                </div>
              </div>
              <span className="chev">›</span>
            </button>
          ) : (
            <p className="games-intro">
              finish a lesson or two first — then your weak spots show up here to
              drill.
            </p>
          )}

          <div className="footnote">
            <Keys />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DrillScreen;
